module.exports = __webpack_public_path__ + "static/media/give.8de8d9da.svg";